module.exports = "bookmark"